import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectUser } from '../../../redux/slices/auth';
import { checkPermissions } from '../../../utils/checkPermissions';

const AuthorizedRoute = ({ children, permission, parentOnly = false }) => {
    const user = useSelector(selectUser);
    const isAuthorized = parentOnly
        ? user?.type === 'Parent'
        : user && checkPermissions(user.type, user.permissions, permission);

    if (!isAuthorized) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AuthorizedRoute;
